<!-- Daily Activity -->
<mat-card class="w-100">
    <mat-card-content>
        <h4 class="text-center mb-56">Historial de Solicitudes</h4>

        <div class="table-responsive">
            <table mat-table [dataSource]="dataSource" class="text-nowrap w-100">
                <!-- Id Column -->
                <ng-container matColumnDef="id">
                    <th mat-header-cell *matHeaderCellDef> N° </th>
                    <td mat-cell class="fw-medium" *matCellDef="let element; let i = index">
                        <ng-container *ngIf="dataSource.paginator">
                            {{ dataSource.paginator.length - (i + dataSource.paginator.pageIndex *
                            dataSource.paginator.pageSize) }}
                        </ng-container>
                    </td>
                </ng-container>

                <!-- Assigned Column -->
                <!-- <ng-container matColumnDef="funcionario">
                    <th mat-header-cell *matHeaderCellDef> Servidor Público </th>
                    <td mat-cell *matCellDef="let element">
                        <p class="mb-0 fw-medium">{{ this.nombre}}</p>
                        <p class="mb-0 fw-normal op-5">{{ this.cargo }}</p>
                    </td>
                </ng-container>-->

                <!-- Project Column -->
                <ng-container matColumnDef="solicitud">
                    <th mat-header-cell *matHeaderCellDef> Tipo de Solicitud </th>
                    <td mat-cell *matCellDef="let element">
                        <p class="mb-0 fw-medium op-5">{{ capitalizeFirst(element?.id_contenido?.titulo) || ""}}</p>
                    </td>
                </ng-container>

                <!-- Priority Column -->
                <ng-container matColumnDef="fecha">
                    <th mat-header-cell *matHeaderCellDef> Fecha Envío </th>
                    <td mat-cell *matCellDef="let element">
                        <p class="mb-0 fw-medium">{{this.fechaConvert(element.fecha_envio | date: 'dd/MM/yyyy')}}</p>
                    </td>
                </ng-container>

                <ng-container matColumnDef="trayectoria">
                    <th mat-header-cell *matHeaderCellDef> Proceso </th>
                    <td mat-cell *matCellDef="let element">
                        <div class="trayectoria-wrapper">

                            <div class="paso-item">
                                <mat-icon class="paso-icon activo"
                                    [matTooltip]="'Enviado por el funcionario el ' + (element.fecha_envio | date: 'dd/MM/yyyy HH:mm')">
                                    person
                                </mat-icon>
                            </div>

                            <ng-container *ngFor="let paso of element.historial_aprobacion">
                                <mat-icon class="flecha-separador">chevron_right</mat-icon>
                                <div class="paso-item">
                                    <mat-icon class="paso-icon" [ngClass]="{
                                        'aprobado': paso.decision === 'APROBADO' || paso.decision === 'PENDIENTE', 
                                        'rechazado': paso.decision === 'RECHAZADO' || paso.decision === 'DENEGADO'
                                    }" [matTooltip]="(paso.decision === 'PENDIENTE' ? 'Visto Bueno' : paso.decision) + ' por: ' + 
                                                 paso.id_registro?.id_funcionario?.nombre + ' ' + 
                                                 paso.id_registro?.id_funcionario?.paterno + 
                                                 ' (' + paso.id_registro?.id_cargo?.nombre + ') - ' + 
                                                 (paso.fecha | date: 'dd/MM/yyyy HH:mm')">

                                        {{ paso.decision === 'APROBADO' || paso.decision === 'PENDIENTE' ?
                                        'check_circle' : 'cancel' }}
                                    </mat-icon>
                                </div>
                            </ng-container>

                            <ng-container *ngIf="element.estado === 'ENVIADO'">
                                <mat-icon class="flecha-separador pulse">chevron_right</mat-icon>
                                <div class="paso-item">
                                    <mat-icon class="paso-icon pendiente"
                                        [matTooltip]="'En espera de revisión por: ' + (element.nombre_cargo_pendiente)">
                                        watch_later
                                    </mat-icon>
                                </div>
                            </ng-container>

                            <ng-container *ngIf="element.estado === 'PENDIENTE'">
                                <mat-icon class="flecha-separador pulse">chevron_right</mat-icon>
                                <div class="paso-item">
                                    <mat-icon class="paso-icon pendiente"
                                        [matTooltip]="'En espera de revisión por:   RRHH'">
                                        watch_later
                                    </mat-icon>
                                </div>
                            </ng-container>

                            <ng-container *ngIf="element.estado === 'APROBADO'">
                                <mat-icon class="flecha-separador">chevron_right</mat-icon>
                                <div class="paso-item">
                                    <mat-icon class="paso-icon aprobado"
                                        [matTooltip]="'Proceso finalizado y aprobado' + 
                                                (element.historial_aprobacion?.length ? ' el ' + (element.historial_aprobacion[element.historial_aprobacion.length - 1].fecha | date: 'dd/MM/yyyy HH:mm') : '')">
                                        verified
                                    </mat-icon>
                                </div>
                            </ng-container>
                        </div>
                    </td>
                </ng-container>

                <ng-container matColumnDef="estado">
                    <th mat-header-cell *matHeaderCellDef> Estado </th>
                    <td mat-cell *matCellDef="let element">
                        <span
                            class="estado estado-{{element.estado | lowercase}}">{{capitalizeFirst((element.estado).toLowerCase())}}</span>
                    </td>
                </ng-container>

                <!-- Budget Column -->
                <ng-container matColumnDef="option">
                    <th mat-header-cell *matHeaderCellDef> </th>
                    <td mat-cell *matCellDef="let element">
                        <p class="mb-0 fw-medium" *ngIf="element.estado === 'ENVIADO'"
                            (click)="editarSolicitud(element, false)">
                            <button mat-raised-button class=" btn btn-primary d-flex align-items-center">
                                <mat-icon class=" me-2">edit</mat-icon>
                                Editar
                            </button>
                        </p>

                        <p class="mb-0 fw-medium" *ngIf="element.estado !== 'ENVIADO'"
                            (click)="editarSolicitud(element, true)">
                            <button mat-raised-button class=" btn btn-primary d-flex align-items-center">
                                <mat-icon class=" me-2">visibility_on</mat-icon>
                                Detalle
                            </button>
                        </p>
                    </td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
            </table>
            <mat-paginator [pageSizeOptions]="[3, 20, 50, 100]" showFirstLastButtons>
            </mat-paginator>
        </div>
    </mat-card-content>
</mat-card>